import { createAction, props } from '@ngrx/store';
import { SavedSearchResponse } from '../../models/core-apis/saved-search.interfaces';

enum SavedSearchActionTypes {
  loadSavedSearch = '[flight-shop book widget] load saved search',
  loadSavedSearchSuccess = '[flight-shop book widget] load saved search success',
  loadSavedSearchFailure = '[flight-shop book widget] load saved search failure'
}

export const LoadSavedSearch = createAction(
  SavedSearchActionTypes.loadSavedSearch
);

export const LoadSavedSearchSuccess = createAction(
  SavedSearchActionTypes.loadSavedSearchSuccess,
  props<{ savedSearchResponse: SavedSearchResponse }>()
);

export const LoadSavedSearchFailure = createAction(
  SavedSearchActionTypes.loadSavedSearchFailure
);
